/**
 * A central configuration file for game tuning constants.
 */
export const TUNE = {
  // The amount of energy required to perform one action.
  ACTION_COST: 3600,
  // The duration for standard animations like move, turn, and attack jabs.
  ANIMATION_DURATION: 150,
};
